// src/lang/index.js
import { createI18n } from 'vue-i18n'

// === 1. 中文包 ===
const zh = {
  nav: {
    about: '关于我们',
    news: '最新动态',
    services: '创新创业服务',
    insights: '产业洞察',
    partners: '合作单位',
    contact: '咨询答疑',
    join: '如何加入',
    login: '立即加入', // 对应按钮 "立即加入"
    view_news: '查看新闻'
  },
  hero: {
    title: '国际青年科创社区',
    subtitle: '让创意落地 让创新发生',
    desc: '全要素赋能｜资源精准链接｜国际化成长生态',
    tags: {
      invest: '投资', talent: '人才', tech: '技术', policy: '政策', market: '市场', promo: '宣传'
    }
  },
  section: {
    news: '最新动态',
    news_sub: 'NEWS & TRENDS',
    services: '创新创业服务',
    services_sub: 'SERVICES & ECOSYSTEM',
    insights: '产业洞察与政策库',
    partners: '合作单位',
    partners_sub: 'OUR PARTNERS',
    about: '关于我们',
    contact: '准备好加入了吗？',
    contact_sub: '立即加入国际青年科创社区，开启您的创新之旅'
  },
  // 关于我们的 5 个服务对象 (这是重点)
  about: {
    lead_1: '汇聚全球智慧，赋能青年创新。',
    lead_2: '链接不同创新主体，提供从政策咨询到成果转化的精准方案。',
    btn: '了解更多概况',
    gov: '政府部门',
    gov_desc: '提供科技人才引进方案、区域创新政策咨询与产业升级规划服务，助力政府招才引智。',
    ent: '企业',
    ent_desc: '助力技术攻关、投融资对接与市场拓展，加速创新成果落地，赋能企业数字化转型。',
    park: '产业园区',
    park_desc: '赋能园区科创生态建设，精准导入优质项目与高层次人才，打造特色产业集群。',
    social: '社会机构',
    social_desc: '搭建跨界交流平台，促进资源共享，推动社会组织与科创力量的深度融合与协同发展。',
    uni: '高校院所',
    uni_desc: '推动科研成果转化与产业化，深化产教融合，构建人才联合培养与实习实训基地。'
  },
  // 底部按钮
  footer: {
    join: '立即加入',
    contact: '联系咨询'
  }
}

// === 2. 英文包 ===
const en = {
  nav: {
    about: 'About Us',
    news: 'News',
    services: 'Services',
    insights: 'Insights',
    partners: 'Partners',
    contact: 'Contact',
    join: 'How to Join',
    login: 'Join Now',
    view_news: 'View News'
  },
  hero: {
    title: 'Intl Youth Sci-Tech Community',
    subtitle: 'Make Ideas Real, Make Innovation Happen',
    desc: 'Full Empowerment | Precise Resource Linking | Global Ecosystem',
    tags: {
      invest: 'Invest', talent: 'Talent', tech: 'Tech', policy: 'Policy', market: 'Market', promo: 'Promo'
    }
  },
  section: {
    news: 'Latest News',
    news_sub: 'NEWS & TRENDS',
    services: 'Innovation Services',
    services_sub: 'SERVICES & ECOSYSTEM',
    insights: 'Industry Insights & Policies',
    partners: 'Our Partners',
    partners_sub: 'OUR PARTNERS',
    about: 'About Us',
    contact: 'Ready to Join?',
    contact_sub: 'Join our community now and start your innovation journey.'
  },
  about: {
    lead_1: 'Gathering global wisdom, empowering youth innovation.',
    lead_2: 'Linking innovation entities, providing precise solutions from policy to commercialization.',
    btn: 'Learn More',
    gov: 'Government',
    gov_desc: 'Providing talent introduction, policy consulting, and industrial planning to assist in talent attraction.',
    ent: 'Enterprises',
    ent_desc: 'Assisting in R&D, financing, and market expansion to accelerate innovation and digital transformation.',
    park: 'Industrial Parks',
    park_desc: 'Empowering ecosystem construction, introducing high-quality projects and talents to build clusters.',
    social: 'Social Inst.',
    social_desc: 'Building cross-border platforms to promote resource sharing and integration of social organizations.',
    uni: 'Universities',
    uni_desc: 'Promoting achievement transformation, deepening industry-education integration, and building training bases.'
  },
  footer: {
    join: 'Join Now',
    contact: 'Contact Us'
  }
}

// === 3. 创建实例 ===
const i18n = createI18n({
  legacy: false, // 使用组合式 API 模式
  locale: 'zh',  // 默认中文
  fallbackLocale: 'en',
  messages: { zh, en }
})

export default i18n